import { Box, Typography } from '@mui/material'
import React from 'react'
import '../../pages/AdminDashboard/admindashboard.css';
import { Col } from 'antd';
const CustomCard = ({title,count,icon})=> {
  return (
     <Box className="custom-card">
        <Box className="custom-card-content">
          <Box className="custom-card-text">
            <Typography sx={{color:"#6b7280", opacity:1}}>{title}</Typography>
            <Typography  sx={{fontSize:"25px !important" ,fontWeight:'bold'}}>{count}</Typography> 
          </Box>   
           <Box className="custom-card-icon">{icon}</Box>
          </Box> 
        </Box>
  )
}

export default CustomCard